import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { silentSpinnerHeaders } from 'src/app/constants/api-enums';
import { BaseServiceService } from 'src/Services/base-service.service';

@Injectable({
  providedIn: 'root'
})
export class ChatWithExpertService extends BaseServiceService {

  chatId= '';
  hashId = '';


  public connectWithAgent(hostUrl:string, body:object): Observable<any> {
    const url = hostUrl+'/restapi/mhc-start-chat';
    const httpHeaders: HttpHeaders = new HttpHeaders({
     'Access-Control-Allow-Origin': '*' , 'X-Show-silent-Spinner': 'true'
    });
    return super.makeLiveChatPostRequest(url, body, httpHeaders) as Observable<any>;
  }

  public connectWithAgentCreds(hostUrl:string, body:object): Observable<any> {
    const httpHeaders: HttpHeaders = new HttpHeaders({
     'Access-Control-Allow-Origin': '*', 'X-Show-silent-Spinner': 'true'
    });
    return super.makeLiveChatPostRequest(hostUrl, body, httpHeaders) as Observable<any>;
  }

}
